module.exports = __webpack_public_path__ + "img/Kworktech_logo_website_White.0f24487d.jpg";